// Aufgrund diverser Fehler bei der Zeichenkodierung müssen hier entsprechende
// Zeichen von Hand ersetzt werden
// Die Funktion kann dann nach import überall eingesetzt werden

export default function handleCharacterEncoding(text) {
  let textToReplace = text;
  textToReplace = textToReplace
    .replace(/u&#776;/g, 'ü')
    .replace(/a&#776;/g, 'ä')
    .replace(/o&#776;/g, 'ö')
    .replace(/&#8230;/g, '...')
    .replace(/&#180;/g, "'")
    .replace(/&#8221;/g, '"')
    .replace(/&#8211;/g, '-')
    .replace('<sup>2</sup>', '2')
    .replace(/&#128640;/g, '🚀');
  return textToReplace;
}

// Evtl. noch brauchbare Funktionen:

/* Begrenzt die Zahl eines Strings auf 150 Zeichen
function limitUntertitelLength(untertitelString) {
  let startString = untertitelString || " ";
  let maxLength = 150;
  let outputString =
    startString.length > maxLength
      ? startString.substring(0, maxLength) + "..."
      : startString;
  return outputString;
}
*/
